"use client";

import { createContext, useContext } from "react";
import type { PortfolioSection } from "../types";

/** 섹션 하나의 데이터 상태. 최초 로딩 중에는 empty를 신뢰할 수 없다. */
export interface SectionStatus {
  loading: boolean;
  empty: boolean;
}

export interface SectionStatusContextValue {
  /** 섹션이 자신의 로딩/보유 상태를 부모(WalletPortfolioBody)에 보고한다. */
  report: (key: PortfolioSection, status: SectionStatus) => void;
  /** 섹션 언마운트 시 보고를 철회한다. */
  unregister: (key: PortfolioSection) => void;
}

/**
 * 각 섹션이 "보유 자산 없음" 여부를 부모에 보고하기 위한 컨텍스트.
 * - 섹션 카드: 자산이 없으면 스스로 숨는다(SectionCard가 null 반환).
 * - 부모: 노출 대상 섹션이 전부 empty로 확정되면 전역 빈 화면을 그린다.
 * Provider 밖에서 쓰이면(스토리북/단독 렌더) no-op으로 동작한다.
 */
export const SectionStatusContext =
  createContext<SectionStatusContextValue | null>(null);

export function useSectionStatusReporter() {
  return useContext(SectionStatusContext);
}
